export const endorsementEndpoints = (builder) => ({
  // Get all endorsements for a policy (moduleType = H/M/O, policyId = EntryId)
  getEndorsementsByPolicy: builder.query({
    query: ({ moduleType, policyId }) => ({
      url: `/GeneralInsurance/endorsements/${moduleType}/${policyId}`,
      method: 'GET',
    }),
    providesTags: (result, error, { moduleType, policyId }) => [
      { type: 'Endorsement', id: `${moduleType}_${policyId}` }
    ],
  }),

  // Get a single endorsement with its documents
  getEndorsementById: builder.query({
    query: (id) => ({
      url: `/GeneralInsurance/endorsement/${id}`,
      method: 'GET',
    }),
    providesTags: (result, error, id) => [{ type: 'Endorsement', id }],
  }),

  // Add or Update endorsement (pass endorsementId=0 or omit for new)
  saveEndorsement: builder.mutation({
    query: (data) => ({
      url: '/GeneralInsurance/save-endorsement',
      method: 'POST',
      body: data,
    }),
    invalidatesTags: (result, error, arg) => [
      { type: 'Endorsement', id: `${arg.moduleType}_${arg.policyId}` }
    ],
  }),

  // Endorsement Intimation - Fetch policies by customer
  getPoliciesByCustomer: builder.query({
    query: (customerId) => ({
      url: `/GeneralInsurance/policies-by-customer/${customerId}`,
      method: 'GET',
    }),
    providesTags: ['Policy'],
  }),

  // Endorsement Intimation - Send Email
  sendEndorsementIntimation: builder.mutation({
    query: (data) => ({
      url: '/GeneralInsurance/send-endorsement-intimation',
      method: 'POST',
      body: data,
    }),
  }),

  // Hard delete endorsement
  deleteEndorsement: builder.mutation({
    query: (id) => ({
      url: `/GeneralInsurance/endorsement/${id}`,
      method: 'DELETE',
    }),
    invalidatesTags: ['Endorsement'],
  }),
});
